module.exports = __webpack_public_path__ + "static/img/16.c760d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/16.jpg
// module id = pEvt
// module chunks = 15